<form [formGroup]="form" (ngSubmit)="guardar()" class="p-6 space-y-5">

  @if (error) {
  <div class="p-3 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <p class="text-sm text-error-600 dark:text-error-400">{{ error }}</p>
  </div>
  }

  <div>
    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Número (E.164) <span class="text-error-500">*</span>
    </label>
    <input
      type="text"
      formControlName="phoneNumber"
      placeholder="+5117654321"
      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm font-mono text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
    />
    @if (hasError('phoneNumber')) {
    <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ getError('phoneNumber') }}</p>
    }
  </div>

  <div>
    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Tipo de número <span class="text-error-500">*</span>
    </label>
    <select
      formControlName="numberType"
      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90">
      @for (opt of numberTypeOptions; track opt.value) {
      <option [value]="opt.value">{{ opt.label }}</option>
      }
    </select>
  </div>

  <div>
    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Nombre / etiqueta
    </label>
    <input
      type="text"
      formControlName="friendlyName"
      placeholder="Ej. Lima — línea principal"
      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
    />
    @if (hasError('friendlyName')) {
    <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ getError('friendlyName') }}</p>
    }
  </div>

  <div>
    <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
      Twilio SID <span class="text-xs text-gray-400 dark:text-gray-500">(opcional)</span>
    </label>
    <input
      type="text"
      formControlName="twilioSid"
      placeholder="PNxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx"
      class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm font-mono text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
    />
    @if (hasError('twilioSid')) {
    <p class="mt-1 text-xs text-error-600 dark:text-error-400">{{ getError('twilioSid') }}</p>
    }
  </div>

  <div class="grid grid-cols-2 gap-3">
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Agente asignado (id)
      </label>
      <input
        type="number"
        formControlName="agentId"
        placeholder="—"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
    </div>
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Team asignado (id)
      </label>
      <input
        type="number"
        formControlName="teamId"
        placeholder="—"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
    </div>
  </div>

  <div class="grid grid-cols-2 gap-3">
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Setup cost (USD)
      </label>
      <input
        type="number"
        step="0.01"
        formControlName="setupCost"
        placeholder="0.00"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
    </div>
    <div>
      <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
        Monthly cost (USD)
      </label>
      <input
        type="number"
        step="0.01"
        formControlName="monthlyCost"
        placeholder="0.00"
        class="dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
      />
    </div>
  </div>

  <div class="flex items-center gap-6">
    <label class="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        formControlName="isActive"
        class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-800"
      />
      <span class="text-sm text-gray-700 dark:text-gray-300">Activo</span>
    </label>
    <label class="flex items-center gap-2 cursor-pointer">
      <input
        type="checkbox"
        formControlName="isDefault"
        class="w-4 h-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-800"
      />
      <span class="text-sm text-gray-700 dark:text-gray-300">Marcar como default outbound</span>
    </label>
  </div>

  <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
    <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
    <app-button variant="primary" type="submit" [disabled]="saving">
      {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Guardar') }}
    </app-button>
  </div>
</form>
